export const AGGREGATED_REACTIONS_BAR_TEST_ID = "aggregated-reactions-bar";
